import { NgModule }      from '@angular/core';
import { IonicModule } from 'ionic-angular';


//Providers
import { SBSuiteManager } from './providers/sbsuite.manager';
import { RequestService } from './providers/request.service';


/**
 * Módulo de SBSuite:
 * - Gestor de SBSuite
 * - Servicio de peticiones
 *
 * @export
 * @class SBSuiteModule
 */
@NgModule({
    imports:      [ IonicModule ],
    declarations: [  ],
    exports:      [  ],
    providers: [ SBSuiteManager, RequestService ],
})
export class SBSuiteModule{}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/sbsuite.module.ts